import React, { Fragment, useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withRouter from 'react-router/withRouter';
import { get } from 'lodash';
import axios from 'axios';
import AdContainer from '../../../components/ad/AdContainer';
import loadDataYear from '../list_pages/mic_year_modern_page_state_manager';
import { MicLayout } from '../../../fc-components/main/containers/MicLayout/MicLayout';
import VideoModule from '../../../components/video_module/video_module';
import { StickyBar } from '../../../components/StickyBar/StickyBar';
import {
  Carousel,
  FranchiseList,
  FranchiseVertical,
  Image,
  Promotion,
  Section,
  Spacer,
  Text,
  Supplemental,
  ModernTabs,
  ModernTab
} from '../../../fc-components/main/components';
import { UserContext } from '../../../components/context/userContext';
import PremiumPaywall from '../../../components/PremiumPaywall/PremiumPaywall';

const MicYearModernPage = ({
  micPage,
  micYearData,
  config,
  match: { params }
}) => {
  /* Supplemental Info */
  const supplementalTop = get(
    micPage,
    'data.acf.supplemental_information_top',
    {}
  );
  const supplementalBottom = get(
    micPage,
    'data.acf.supplemental_information_bottom',
    {}
  );

  /* Video Unit */
  const videoUnit = get(micPage, 'data.acf.video_unit', {});
  const playlistId = get(videoUnit, 'playlist_id', 'C8Bhwwtx');
  const playerId = get(videoUnit, 'player_id', '76APbejE');
  const showVideo = get(videoUnit, 'show_video_unit', false);

  /* Interstitial */
  const interstitial = get(micPage, 'data.acf.interstitial', null);

  /* General Page */

  let micListData = get(micYearData, 'data.externalList', []);
  let micSectorsData = get(micYearData, 'data.externalSectors', []);
  const seoHed = get(micPage, 'data.acf.franchise_title', '');
  const seoSubHed = get(micPage, 'data.acf.franchise_dek', '');
  const franchiseHeroImageDesktop = get(
    micPage,
    'data.acf.franchise_images.franchise_hero_image_desktop',
    undefined
  );

  const franchiseHeroImageMobile = get(
    micPage,
    'data.acf.franchise_images.franchise_hero_image_mobile',
    undefined
  );

  const franchiseContributors = get(
    micPage,
    'data.acf.franchiseContributors',
    undefined
  );
  const franchiseBlurb = get(micPage, 'data.acf.franchise_blurb', undefined);
  const franchiseBlurbImage = get(
    micPage,
    'data.acf.franchise_images.franchise_blurb_image',
    undefined
  );

  /*  CTA Promo  */
  const ctaShowPromo = get(
    micPage,
    'data.acf.cta_promo.ctaShowPromo',
    undefined
  );
  const ctaImage = get(micPage, 'data.acf.cta_promo.ctaImage', undefined);
  const ctaHeadline = get(micPage, 'data.acf.cta_promo.ctaHeadline', undefined);
  const ctaDescription = get(
    micPage,
    'data.acf.cta_promo.ctaDescription',
    undefined
  );
  const ctaUrl = get(micPage, 'data.acf.cta_promo.ctaUrl', undefined);
  const ctaButtonText = get(
    micPage,
    'data.acf.cta_promo.ctaButtonText',
    undefined
  );

  const { hasPaywallAccess } = useContext(UserContext);
  if (!hasPaywallAccess()) {
    micListData = [...micListData].slice(0, 2);
    micSectorsData = [...micSectorsData].slice(0, 2);
  }
  /* Set Dynamic Variables */
  const [videoData, setVideoData] = useState(undefined);
  const [listFinal, setListFinal] = useState(undefined);
  const [isMobile, setIsMobile] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const handleRank = rank => {
    if (rank < 10) {
      return `0${rank}`;
    }
    return rank;
  };

  const buildListData = list =>
    list.map((record, idx) => ({
      description: '',
      rank: handleRank(get(record, 'Rank')),
      altLink: get(record, 'Article Link', ''),
      title: get(record, 'Company Name', ''),
      blurb: get(record, 'For Line', 'none'),
      canCollapse: false,
      socialText: `${escape(get(record, 'Company Name', ''))} is No. ${parseInt(
        idx + 1,
        10
      )} on Fast Company's list of the Most Innovative Companies of 2023`
    }));

  const buildSectorData = sectors =>
    sectors.map(sector => ({
      withArrow: true,
      title: get(sector, 'Sector Name', ''),
      altLink: get(sector, 'Article Link', ''),
      blurb: get(sector, 'Description', ''),
      showShare: false,
      description: '',
      ranked: false,
      canCollapse: false,
      disableToggle: true
    }));

  const handleVideoModule = () => {
    const host = 'content.jwplatform.com';
    const cacheKeyUrl = `https://${host}/feeds/${playlistId}.json`;

    // Fetch and setup video player from JW playlist
    axios.get(cacheKeyUrl).then(response => {
      setVideoData(response.data);
    });
  };

  const handleStickyBar = () => {
    setListFinal([{ category: 'Top 50' }, { category: 'Sectors' }]);
  };

  const checkIfMobile = x => {
    setIsMobile(x.matches);
  };

  const goToTopOfList = () => {
    const distance =
      window.pageYOffset +
      document.querySelector('.tabs__navigation').getBoundingClientRect().top;
    window.scrollTo({ top: distance - 90, left: 0, behavior: 'smooth' });
  };

  const buildInterstitalComponents = index => (
    <div>
      {get(interstitial, 'length', 0) > 0 &&
        get(interstitial, `[${index}].articles`, false) && (
          <Fragment>
            <Carousel
              fullWidth
              fade
              articles={interstitial[index].articles.map(singleArticle => ({
                header: get(singleArticle, 'franchise_header', ''),
                title: get(singleArticle, 'title', ''),
                deck: get(singleArticle, 'subtitle', ''),
                image: get(singleArticle, 'image.url', ''),
                buttonText: get(singleArticle, 'button_text', ''),
                url: get(singleArticle, 'button_url', '')
              }))}
              // articles={interstitial.map((carouselObj) => {
              //   const articles = get(carouselObj,'articles', []);
              //     articles.map(singleArticle => ({
              //       header: get(singleArticle, 'franchise_header', ''),
              //       title: get(singleArticle, 'title', ''),
              //       deck: get(singleArticle, 'subtitle', ''),
              //       image: get(singleArticle, 'image.url', ''),
              //       buttonText: get(singleArticle, 'button_text', ''),
              //       url: get(singleArticle, 'button_url', '')
              //     }))
              //   })
              // }
            />
            <Spacer height="20px" />
          </Fragment>
        )}
      <div className="post__article-top-ad-wrapper">
        <AdContainer type="break" />
      </div>
    </div>
  );

  useEffect(() => {
    const x = window.matchMedia('(max-width: 640px)');
    handleVideoModule();
    handleStickyBar();
    checkIfMobile(x);
  }, []);

  return (
    <MicLayout year="2023">
      <div id="editorialLander">
        <Section name="mic_vertical">
          <FranchiseVertical
            hed={seoHed}
            subHed={seoSubHed}
            verticalImg={franchiseHeroImageDesktop}
            verticalImgMobile={franchiseHeroImageMobile}
            caption="Illustration by Anil Rinat"
          />
        </Section>

        <Section name="mic__blurb" maxWidth={970} vMargins="20">
          <div className="introText">
            <Text>
              <Image image={franchiseBlurbImage} width="90px" float="left" />
              {franchiseBlurb && (
                <Text>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: franchiseBlurb
                    }}
                  />
                </Text>
              )}
            </Text>
          </div>
        </Section>

        <ModernTabs
          overrideTabs={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        >
          <ModernTab label="Top 50">
            <Section name="top_50" noPadding vMargins="20">
              {micListData && (
                <FranchiseList
                  items={buildListData(micListData)}
                  bgColor="#fff"
                  interstitialConfig={{
                    every: 10,
                    bgColor: '#fff',
                    renderComponent: index => buildInterstitalComponents(index)
                  }}
                  params={params}
                  preventEvent
                />
              )}
            </Section>
          </ModernTab>
          <ModernTab label="Sectors">
            <Section name="sectors" noPadding vMargins="20">
              {micSectorsData && (
                <FranchiseList
                  items={buildSectorData(micSectorsData)}
                  bgColor="#fff"
                  interstitialConfig={{
                    every: 9,
                    bgColor: '#fff',
                    renderComponent: () => (
                      <div className="post__article-top-ad-wrapper">
                        <AdContainer type="break" />
                      </div>
                    )
                  }}
                  params={params}
                  preventEvent
                />
              )}
            </Section>
          </ModernTab>
        </ModernTabs>
        {!hasPaywallAccess() && <PremiumPaywall />}

        <Section name="mic__credits" maxWidth={970}>
          <div dangerouslySetInnerHTML={{ __html: franchiseContributors }} />
        </Section>

        <Section name="mic_dropdowns" maxWidth={970}>
          <Supplemental {...supplementalTop} />
          <Supplemental {...supplementalBottom} />
        </Section>

        {ctaShowPromo && (
          <Section
            noPadding
            name="mic__event__promotion"
            vMargins="40"
            bgColor="#000000"
          >
            <Promotion
              promoImage={ctaImage}
              promoDate={ctaHeadline}
              promoDescription={ctaDescription}
              promoUrl={ctaUrl}
              bgColor="#00C3FF"
              hovercolor="#00C3FF"
              overrideLabel={ctaButtonText}
            />
          </Section>
        )}

        {videoData &&
          showVideo && (
            <Section name="mic__videoModule" vMargins="40" bgColor="#ffffff">
              <h2 className="module__title">{get(videoData, 'title', '')}</h2>
              <div
                className="module__blurb"
                dangerouslySetInnerHTML={{
                  __html: get(videoData, 'description', '')
                }}
              />
              <VideoModule
                hideHeader={true}
                config={config}
                data={videoData}
                playerid={playerId}
                stories={get(videoData, 'playlist', [])}
              />
            </Section>
          )}
      </div>
      <StickyBar
        slug="mic-2023"
        location="lander"
        post={{
          id: 'most-innovative-companies',
          slug: 'mic-2023',
          title: 'Fast Company'
        }}
        isMobile={isMobile}
        externalData={listFinal}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        svgWidth={15}
        svgHeight={15}
        scroll={goToTopOfList}
      />
    </MicLayout>
  );
};

MicYearModernPage.loadData = (store, year) => loadDataYear(store, year);

function mapStateToProps(state = {}) {
  const micData = get(state, 'micYear.data', {});
  return {
    config: state.config,
    status: state.status.code,
    micPage: state.micYear,
    micYearData: state.micYearPage,
    micPageData: micData || {}
  };
}

MicYearModernPage.propTypes = {
  micPage: PropTypes.shape({}).isRequired,
  micYearData: PropTypes.shape({}).isRequired,
  status: PropTypes.string, // eslint-disable-line
  match: PropTypes.shape({}),
  config: PropTypes.shape({})
};

MicYearModernPage.defaultProps = {
  match: {},
  status: undefined,
  config: {}
};

export default withRouter(connect(mapStateToProps)(MicYearModernPage));
